
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import CustomerStateHandler from '@customer/components/CustomerStateHandler.vue';

dayjs.locale('lt');
dayjs.extend(duration);

interface Props {
  article: ArticleData;
}

interface Computed {
  isLoggedIn: boolean;
  hasChannelAccess: boolean;
  showCountdown: boolean;
}

interface Data {
  countdown: number;
  countdownText: string;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  components: {
    CustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      countdown: 0,
      countdownText: '00:00:00',
    };
  },
  computed: {
    isLoggedIn() {
      return this.$instanceConnector('customer').state.isLoggedIn;
    },
    hasChannelAccess() {
      return this.$instanceConnector('paywall').state.hasChannelAccess;
    },
    showCountdown() {
      return this.article.content.paywall.enabled && this.countdown > 0;
    },
  },
  watch: {
    countdown: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.countdown--;
            this.countdownText = dayjs.duration(this.countdown, 'seconds').format('HH:mm:ss');
          }, 1000);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.article.content.paywall.enabled && this.article.content.paywall.disableAt) {
      const disableAt = new Date(this.article.content.paywall.disableAt).toString();
      const disableAtDate = dayjs(disableAt);
      const now = dayjs();
      const diff = disableAtDate.diff(now, 'second');
      if (diff > 0) {
        this.countdown = diff;
      }
    }
  },
});
